import React from 'react';
import {
  Globe,
  Heart,
  TrendingUp,
  BarChart3,
  Users,
  Workflow,
} from 'lucide-react';
import Contours from './Contours';
import './About.css';

const missionCards = [
  {
    icon: <Globe />,
    title: 'Sustainable Innovation',
    desc: 'We integrate responsible practices into all innovations — be it industrial, social, or ESG goals.',
  },
  {
    icon: <Heart />,
    title: 'Human-Centric Approach',
    desc: 'We put empathy and ethics before AI, ensuring technology enhances human well-being.',
  },
  {
    icon: <TrendingUp />,
    title: 'Risk Reduction',
    desc: 'We help businesses reduce disruption risk through strategic planning, compliance reporting and data governance.',
  },
];

const expertiseCards = [
  {
    icon: <BarChart3 />,
    title: 'Data Strategy & Analytics',
    desc: 'We transform data into actionable insights that fuel sustainable business decisions.',
  },
  {
    icon: <Users />,
    title: 'Customer Experience',
    desc: 'We enhance customer journeys through data, personalization, and ethical engagement through CX Analytics.',
  },
  {
    icon: <Workflow />,
    title: 'Data Governance',
    desc: 'We align people, process, and technology through data governance to build adaptive, future-ready organizations.',
  },
];

const About = () => {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">About Sustune</span>
          <h1>
            Technology with empathy,
            <br />
            strategy with patience.
          </h1>
          <p className="page-hero-sub">
            Our vision is to bring sustainability into thinking, actions, and
            innovations — transforming organizations through sustainable
            strategy and human-centric innovation.
          </p>
        </div>
      </section>

      {/* Who we are — editorial two-column */}
      <section className="who-band">
        <div className="wrap who-grid">
          <div className="who-label">
            <span className="eyebrow">Who we are</span>
          </div>
          <div className="who-text">
            <p className="lead-para">
              We are a startup committed to bringing sustainable thinking into
              every industry. With over two decades of collective experience
              across our expert team, we help create strategy for long-term
              growth.
            </p>
            <p>
              Our mission is to help businesses evolve responsibly — with
              empathy, purpose, and vision. We blend modern technologies with
              thoughtful practices to elevate customer experience, operational
              excellence, and strategic analytics.
            </p>
            <p>
              With our registered office in Bengaluru, we are steadily growing
              and serve global organizations through our partner ecosystem.
            </p>
          </div>
        </div>
      </section>

      {/* Mission — dark band */}
      <section className="mission-band on-dark">
        <div className="wrap">
          <span className="eyebrow">Our mission</span>
          <h2 className="section-title">What we hold ourselves to.</h2>
          <div className="card-trio">
            {missionCards.map((c) => (
              <div key={c.title} className="dark-card">
                <span className="dark-card-icon">{c.icon}</span>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise */}
      <section className="expertise-band">
        <div className="wrap">
          <span className="eyebrow">Our expertise</span>
          <h2 className="section-title">Where we go deep.</h2>
          <div className="card-trio">
            {expertiseCards.map((c) => (
              <div key={c.title} className="light-card">
                <span className="light-card-icon">{c.icon}</span>
                <h3>{c.title}</h3>
                <p>{c.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="about-cta-contours">
          <Contours />
        </div>
        <div className="wrap about-cta-inner">
          <h2>Ready to transform sustainably?</h2>
          <p>
            Partner with us to build a future where technology and
            sustainability drive meaningful, lasting success.
          </p>
          <a
            className="btn btn-solid"
            href="mailto:info@sustunetech.com?subject=Consultation%20Enquiry"
          >
            Start the conversation
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
